import React from 'react';
import { Card, CardBody } from '@aidkitorg/component-library';
import { getStageFromRequest } from '../../../SupportUtil';
import { SupportCasePreview } from './SupportCasePreview';
import { SupportCaseListProps } from '../types';
import { useLocalizedStrings } from '../../../Localization';

/**
 * SupportCaseList - Renders a list of support case preview cards
 */
export const SupportCaseList: React.FC<SupportCaseListProps> = ({
  tickets,
  onClaim,
  onTicketClick,
  emptyMessage = 'No support cases found',
  loading = false,
  error = false
}) => {
  const L = useLocalizedStrings();

  if (error) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-red-600">
          {L.admin_panel.support.error_loading}
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-gray-500">{L.admin_panel.support.loading}</div>
      </div>
    );
  }

  if (tickets.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-gray-500">{emptyMessage}</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {tickets.map((ticket) => {
        const stage = getStageFromRequest(ticket);
        const messageCount = ticket.row.count ? parseInt(ticket.row.count, 10) : undefined;

        return (
          <Card key={ticket.row.source} className='bg-gray-50/50'>
            <CardBody>
              <SupportCasePreview
                request={ticket}
                messageCount={messageCount}
                stage={stage}
                onClaim={() => onClaim(ticket)}
                onClick={onTicketClick ? () => onTicketClick(ticket) : undefined}
              />
            </CardBody>
          </Card>
        );
      })}
    </div>
  );
};
